export const MODES = {
  INSERT: 'insert',
  RESULT: 'result',
};

export const TABS = {
  REQUESTS: 'table_1',
  WORDS: 'table_2',
};
